/**
 * 테스트(데모) 회사 관련 클라이언트용 유틸리티 함수
 * Feature 039: DRY 원칙 준수를 위한 헬퍼 함수
 *
 * NOTE: 이 파일은 클라이언트에서 안전하게 사용 가능
 * mongoose 등 서버 전용 의존성 없음
 */

/**
 * 테스트(데모) 회사 제한 에러인지 확인 (클라이언트용)
 * Apollo Client 에러에서 테스트회사 제한 에러를 감지
 * 단계별 방어적 타입 가드를 적용하여 안전하게 접근
 * @param error - Apollo Client 에러 또는 unknown 에러
 * @returns 테스트 회사 제한 에러 여부
 */
export function isTestCompanyLimitError(error: unknown): boolean {
  // 1단계: null/undefined 체크 및 객체 타입 검증
  if (!error || typeof error !== "object") return false;

  // 2단계: graphQLErrors 배열 존재 및 길이 검증
  const gqlErrors = (error as { graphQLErrors?: unknown[] })?.graphQLErrors;
  if (!Array.isArray(gqlErrors) || gqlErrors.length === 0) return false;

  // 3단계: 첫 번째 에러 요소 타입 검증
  const firstError = gqlErrors[0];
  if (!firstError || typeof firstError !== "object") return false;

  // 4단계: extensions 객체 존재 및 타입 검증
  const extensions = (firstError as { extensions?: unknown })?.extensions;
  if (!extensions || typeof extensions !== "object") return false;

  // 5단계: isTestCompanyLimit 플래그 확인
  return (extensions as { isTestCompanyLimit?: boolean }).isTestCompanyLimit === true;
}
